import React from 'react';
import { CheckIcon } from 'lucide-react';
import { ImageCarousel } from './ImageCarousel';
import { wakeUpImage, cardCategories, executiveFunctionTools, sleepAnchorImage, toolkitGallery } from '../data/neuroscience';
const slides = [wakeUpImage, ...cardCategories, sleepAnchorImage, ...toolkitGallery];
export function NeuroscienceSection() {
  return <section aria-labelledby="neuro-heading" className="mx-auto mt-14 max-w-3xl text-center" data-id="element-107" data-mp="a5w5v78s909v">
      {/* Block 1 */}
      <h2 id="neuro-heading" className="font-display text-2xl font-black leading-tight text-plum sm:text-4xl" data-id="element-108" data-mp="3dopk7m9dxt53">
        🧠 The Neuroscience of Autonomy: Why Visuals Work Where Words Fail
      </h2>
      <p className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-plum/70" data-id="element-109" data-mp="3mpdwocj4rlfv">
        If you feel like you’re constantly “nagging,” it’s not a discipline problem. It’s a{' '}
        <span className="font-bold text-blush" data-id="element-110" data-mp="2yx6w116dgsan">neurological bottleneck</span>.
      </p>
      <p className="mx-auto mt-3 max-w-2xl text-base leading-relaxed text-plum/70" data-id="element-111" data-mp="2uvvd1ei075bf">
        A child’s brain processes visual information{' '}
        <span className="font-bold text-blush" data-id="element-112" data-mp="31mm2bfm0bkre">60,000 times faster</span> than verbal language.
        While your words are still being “translated” by their brain, a visual icon has already
        triggered the action.
      </p>

      {/* Block 2 */}
      <h3 className="mt-12 font-display text-2xl font-black leading-tight text-plum sm:text-3xl" data-id="element-113" data-mp="3bf02i3xfsjbg">
        🧩 From Cognitive Overwhelm to Self-Management
      </h3>
      <p className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-plum/70" data-id="element-114" data-mp="2ipb47yc42xdj">
        When you yell orders, you spike your child’s cortisol (stress hormone), which shuts down
        their logical brain. SIGMA SMART™ replaces your voice with a visual roadmap, reducing stress
        and activating the <span className="font-bold text-grape" data-id="element-115" data-mp="2wc1xyo07p1i">Dopamine reward system</span>{' '}
        every time they complete a task.
      </p>

      {/* Block 3 */}
      <h3 className="mt-12 font-display text-2xl font-black leading-tight text-plum sm:text-3xl" data-id="element-116" data-mp="23zcwlbbzlsq1">
        🚀 Built for Every Mind (ADHD & Neuro-Friendly)
      </h3>
      <p className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-plum/70" data-id="element-117" data-mp="1z00cgyci2zr5">
        We don’t just give you a list; we give you{' '}
        <span className="font-bold text-plum" data-id="element-118" data-mp="28ypklzelh5u7">Executive Function Tools</span>. Our high-contrast,
        professional icons are specifically designed to:
      </p>
      <ul className="mx-auto mt-5 flex max-w-md flex-col gap-3 text-left" data-id="element-119" data-mp="1l93o5jplx4pw">
        {executiveFunctionTools.map(t => <li key={t.title} className="flex items-start gap-3 text-sm text-plum/75 sm:text-base" data-id="element-120" data-mp="1u15ir1czvqs9">
            <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-grape" strokeWidth={3} data-id="element-121" data-mp="1pags1o952xu6" />
            <span data-id="element-122" data-mp="1p8chingqj0kx">
              <span className="font-bold text-plum" data-id="element-123" data-mp="11kmgda0k3fbi">{t.title}:</span> {t.desc}
            </span>
          </li>)}
      </ul>

      {/* Block 4 */}
      <h3 className="mt-12 font-display text-2xl font-black leading-tight text-plum sm:text-3xl" data-id="element-124" data-mp="xirf25iml1xq">
        📦 A Massive Toolkit for Real Life
      </h3>
      <p className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-plum/70" data-id="element-125" data-mp="s5stjhcnyn5x">
        This isn’t just a 50-page eBook. It’s a comprehensive library with over{' '}
        <span className="font-bold text-blush" data-id="element-126" data-mp="df224aezhq3c">150+ custom icons and templates</span> covering every
        possible family scenario — from calm mornings to travel transitions.
      </p>

      <div className="mt-8 text-left" data-id="element-127" data-mp="166llpvfht65v">
        <ImageCarousel slides={slides} label="Preview of the visual pages — swipe sideways" data-id="element-128" data-mp="1b4n5yjonnbix" />
      </div>

      <p className="mt-3 text-sm font-semibold text-plum/55" data-id="element-129" data-mp="w85xc07uob02">
        Just a few of the <span className="text-blush" data-id="element-130" data-mp="116qwdwbd8omx">+150 specialized visual pages</span> included.
      </p>
    </section>;
}